import NavBar from './NavBar';
import SideBar from './SideBar';

function Menu() {
    return (
        <>
            <NavBar />
            <SideBar />
        </>
    );
}

export default Menu;
